import React, { useState } from 'react'
import {
  getLocalStorage,
  setLocalStorage,
} from '@multiagentbook/ui'

export interface AppContextType {
  user: null
  logout: () => void
  darkMode: string
  setDarkMode: (mode: string) => void
}

export const appContext = React.createContext<AppContextType>(
  {} as AppContextType
)
const Provider = ({ children }: any) => {
  const [darkMode, setDarkMode] = useState(() => {
    const storedMode = getLocalStorage('designingwithml_darkmode', false)
    if (storedMode === 'dark' || storedMode === 'light') {
      return storedMode
    }
    return 'light'
  })

  const logout = React.useCallback(() => {
    // No-op for static website
  }, [])

  const updateDarkMode = React.useCallback((mode: string) => {
    setDarkMode(mode)
    setLocalStorage('designingwithml_darkmode', mode, false)
  }, [])

  const contextValue = React.useMemo(
    () => ({
      user: null,
      logout,
      darkMode,
      setDarkMode: updateDarkMode,
    }),
    [darkMode, logout, updateDarkMode]
  )

  return (
    <appContext.Provider value={contextValue}>{children}</appContext.Provider>
  );
};

// Export the Provider component directly for Vite/React Router
export default Provider;
